<template>
  <ListDropdown
    ref="dropdown"
    multiple
    class="product-category-dropdown"
    placeholder="Kategorien"
    :value="value"
    :item-url="buildItemUrl"
    :options="options"
    :disabled="isDisabled"
    :include-blank="includeBlank"
    @input="onChange"
    @select="onSelectItem"
    @unselect="onUnselectItem"
  />
</template>

<script>
import ListDropdown from '@/components/list-dropdown.vue';
import traverseAggregations from '@/lib/aggregation-utils/traverse';

export default {
  name: 'ProductCategoryDropdown',
  components: {
    ListDropdown,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    aggregations: {
      type: Array,
      default: () => [],
    },
    itemUrl: {
      type: Function,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    blankText: {
      type: String,
      default: 'Alle Kategorien',
    },
    tree: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['change', 'input'],
  computed: {
    rootAggregation() {
      return this.aggregations.find((agg) => agg.selected);
    },
    rootCategory() {
      if (!this.rootAggregation) return undefined;
      return this.rootAggregation.productCategory;
    },
    rootCategoryPath() {
      if (!this.rootCategory) return undefined;
      return this.rootCategory.path;
    },
    childAggregations() {
      if (!this.rootAggregation || !this.rootAggregation.children) return [];
      return this.rootAggregation.children || [];
    },
    optionAggregations() {
      if (this.tree) return traverseAggregations(this.aggregations);
      return this.childAggregations;
    },
    includeBlank() {
      if (this.tree) return this.blankText;
      return undefined;
    },
    options() {
      if (!this.optionAggregations.length) return [];

      const options = [];

      if (!this.tree) {
        options.push({
          label: this.blankText || this.rootCategory.name,
          value: this.rootCategory.path,
        });
      }

      this.optionAggregations.forEach((aggregation) => {
        options.push({
          label: aggregation.productCategory.name,
          value: aggregation.productCategory.path,
          count: aggregation.offersCount,
          depth: this.tree ? aggregation.productCategory.depth : 0,
        });
      });

      return options;
    },
    isDisabled() {
      return this.disabled || this.options.length === 0;
    },
  },
  methods: {
    buildItemUrl(item) {
      if (!this.itemUrl) return undefined;
      return this.itemUrl(item);
    },
    onChange(value) {
      this.$emit('input', value);
      this.$emit('change', value);
    },
    onSelectItem(selectedValue, values) {
      const { dropdown } = this.$refs;
      const parentPath = this.rootCategoryPath;

      if (selectedValue === parentPath) {
        values.forEach((value) => {
          if (value !== parentPath) {
            dropdown.unselect(value);
          }
        });
      } else {
        dropdown.unselect(parentPath);
      }
    },
    onUnselectItem(unselectedValue, values) {
      if (values.length === 0) {
        this.$refs.dropdown.select(this.rootCategoryPath);
      }
    },
  },
};
</script>
